// extracted by mini-css-extract-plugin
module.exports = {"originalPrice":"_3P5Lv","promoPrice":"_1wIKE","savingsLabel":"_3Q33w"};